@for (page of pages(); track $index) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="translationKeyPrefix()"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    <div class="row g-5">
      @if ($index === 0) {
        <div class="col-12">
          <cfp-portfolio-energy-label-ratings
            [labelDistribution]="portfolioBuildingsRoadmap().labelDistribution"
            [labelGroup]="labelGroup"
            [title]="translationKey('energyLabels.ratings.title')"
            [description]="translationKey('energyLabels.ratings.description')"
            [currentDistributionTitle]="translationKey('energyLabels.ratings.currentDistributionTitle')"
            [improvedDistributionTitle]="translationKey('energyLabels.ratings.improvedDistributionTitle')"
            [subDescription]="
              this.hasBuildingsWithNoPlan()
                ? (translationKey('energyLabels.ratings.subDescription') | translate)
                : ''
            "
            [combineAOrHigher]="false"
            [showLabel]="true"
          />
        </div>
        <div class="col-12">
          <h2>{{ translationKey('energyLabels.registered.title') | translate }}</h2>
          <p>{{ translationKey('energyLabels.registered.body') | translate }}</p>
          @let certifiedLabelsDistribution = labelsCertified()?.certifiedLabelsDistribution?.[labelGroup];
          @if (certifiedLabelsDistribution) {
            <cfp-energy-labels-registered-chart
              [labelsCertified]="certifiedLabelsDistribution"
              [labelGroup]="labelGroup"
              [showDescription]="false"
              [showPercentage]="false"
              [legendTextRegistered]="translationKey('energyLabels.legend.registered')"
              [legendTextExpired]="translationKey('energyLabels.legend.expired')"
              [legendTextNotRegistered]="translationKey('energyLabels.legend.notRegistered')"
            />
          }
        </div>
      }
      <div class="col-12">
        <h2>
          {{
            (translationKey('energyLabels.title') | translate) +
              ($index > 0 ? ' (' + (translationKey('continued') | translate) + ')' : '')
          }}
        </h2>
        <cfp-report-portfolio-roadmap-table
          [years]="years()"
          [buildingsWithPlan]="page"
          [showProperty]="'energyLabel'"
          [currencyCode]="portfolioBuildingsRoadmap().currencyCode"
        />
        @if (showLegend()) {
          <cfp-report-buildings-legend
            [portfolioBuildingsRoadmap]="portfolioBuildingsRoadmap()"
          />
        }
      </div>
    </div>
  </cfp-report-page>
}
